import styled from "styled-components";
import { AutoColumn } from "../../../components/Column";
import { AutoRow, RowBetween } from "../../../components/Row";
import * as jose from 'jose'
import Row from "../../../components/Row";
import useToken from "../../../hooks/useToken";
import { ButtonLight, ButtonOutlined, ButtonPrimary } from "../../../components/Button";
import {
  SecondsToTime,
  fromAmount,
  toAmount,
  toSpecialAmount,
} from "../../../utils/amount";
import { shortenAddress } from "../../../utils";
import CurrencyLogo from "../../../components/CurrencyLogo";
import { Trans } from "@lingui/macro";
import { useWallet } from "use-wallet";
import useWeb3 from '../../../hooks/useWeb3';
import { useEffect, useMemo, useState } from "react";
import { BLOCK_PER_SEC } from "../../../constants/chains";
import { zeroPad } from "react-countdown";
import CreateApiKeyModal from "./CreateApiKeyModal";
import Big from "big.js";
import { TOKEN_ADDRESS } from "../../../constants/address";

const PoolItemWrapper = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 12px;
  background-color: white;
  padding: 1em;
  min-height: 218.5px;
  font-size: 14px;
`;

const APYText = styled.div`
  color: ${({ theme }) => theme.yellow2};
  font-size: 20px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

const ValueText = styled.div`
  font-size: 14px;
`;

const HR = styled.div`
  width: 100%;
  border-bottom: 1px dashed ${({ theme }) => theme.bg2};
`;

function UserItem({ userInfo, userOpt }) {
  // const { account,chainId  } = useWallet(); // getBlockNumber
  const [keyOpen, setKeyOpen] = useState(false);
  console.log("userInfo", userInfo);
  const web3 = useWeb3();
  const { account, chainId } = useWallet();

  const createKey=()=>{
    setKeyOpen(true);
    const Func= async () => {

      const TokenPwd = '123';
      const currentTimeInMilliseconds = new Date().getTime();
      const currentTimeInSeconds = Math.floor(currentTimeInMilliseconds / 1000);
      const message = 'Expiration Time:'+SecondsToTime(currentTimeInSeconds+31536000);
      const sign = await web3.eth.personal.sign(message, account, null);
      console.log('sign:', sign);
      

      const secret = new TextEncoder().encode(
        TokenPwd,
      );
      const token = await new jose.CompactSign(
        new TextEncoder().encode(JSON.stringify({message,signature:sign})),
      ).setProtectedHeader({ alg: 'HS256' }).sign(secret)
        
      
      console.log('Generated JWT:', token);
      
    }
   // Func();
  }

  return (
    <PoolItemWrapper>
      {userInfo && userInfo.endtime ? (
        <AutoColumn gap={"12px"}>
          <RowBetween justify={"space-between"}>
            <AutoRow gap={"8px"}>
              {/* <CurrencyLogo src={token.icon} size={"48px"} /> */}
              <AutoColumn>
                <div style={{ fontSize: "16px" }}>
                  <Trans> UserId-{userInfo.userid}</Trans>
                </div>
                {/*              <div style={ { fontSize: '16px' } }>
                  <Trans>Earn</Trans>
                </div> */}
              </AutoColumn>
            </AutoRow>
            <div>{userInfo.stop ? "Unavailable" : "Valid"}</div>
          </RowBetween>

          <HR />

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>User Address</Trans>
            </div>
            <ValueText>{shortenAddress(userInfo.useraddr)} </ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Login Address</Trans>
            </div>
            <ValueText>{shortenAddress(userInfo.loginaddr)} </ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>End Time</Trans>
            </div>
            <ValueText>{SecondsToTime(userInfo.endtime)} </ValueText>
          </AutoRow>

{/*           <AutoRow justify={"space-between"}>
            <div>
              <Trans>Package</Trans>
            </div>
          </AutoRow>*/}
          <RowBetween> 
            <ButtonLight
            width={"160px"}
            onClick={createKey}
            >
              <Trans>Create API Key</Trans>
            </ButtonLight>
            {/* <ButtonOutlined
              width={"160px"}
            > 
              <Trans>Change Account</Trans>
            </ButtonOutlined> */}
          </RowBetween>
        </AutoColumn>
      ) : null}

<CreateApiKeyModal
        isOpen={keyOpen}
        setIsOpen={setKeyOpen}       
      />
    </PoolItemWrapper>
  );
}

export default UserItem;
